import React from "react";
import { Figure, Img } from "./style";

const Image = ({ src, alt = "" }) => {
  return (
    <Figure>
      <Img src={src} alt={alt} loading="lazy" />
    </Figure>
  );
};

export default Image;
